import { render } from "./SupplyTableRow.vue?vue&type=template&id=399edd4a&ts=true"
import script from "./SupplyTableRow.ts?vue&type=script&lang=ts&external"
export * from "./SupplyTableRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__